// src/services/packets-io.ts
// Thin orchestration layer so components don’t touch formats/persistence details.
import { getPacket, importPacket } from "../persistence/packets";
import { downloadPacketAsDocx } from "../lib/docx-export";
import { parseDocxToNotes } from "../import/docx-import";

export async function exportCurrentPacketAsDocx(packetId: string): Promise<void> {
  const p = await getPacket(packetId);
  if (!p) throw new Error("No packet found.");
  // Pass raw notes; importer will handle derivation later.
  await downloadPacketAsDocx({ name: p.name, notes: p.notes });
}

export async function importDocxFile(
  file: File,
  opts: { merge: boolean; autoTriggers: boolean }
): Promise<{ packetId: string; res: any }> {
  const notes = await parseDocxToNotes(file);
  if (!notes.length) throw new Error("No CueBoards found in file. Check the template format.");

  // If importing as new, use filename stem as packet name
  const filenameBase = file.name.replace(/\.[^/.]+$/, "");
  const payload = opts.merge ? { notes } : { name: filenameBase, notes };

  const res = await importPacket(payload, { merge: opts.merge, autoTriggers: opts.autoTriggers });
  return { packetId: res.packet.id, res };
}
